(function(){
'use strict';

angular.module('classy.frs').component('registrationCartItem', {
  template: '\n      <div class="cart-item"\n        ng-click="!$ctrl.isDisabled && $ctrl.onClick()"\n        ng-class="{ disabled: $ctrl.isDisabled }">\n\n        <div class="cart-item__description">\n          <h3 class="cart-item__headline">\n            <i class="fa fa-tag" ng-style="{ \'color\': $ctrl.primaryColor }" ng-if="$ctrl.hasPromoCode"></i>\n            {{ $ctrl.itemName }}\n          </h3>\n          <p class="cart-item__subitem"\n             tabindex="0"\n             role="button"\n             aria-label="{{ $ctrl.getSubitemName(subitem, $index)}} price {{$ctrl.itemPrice}}"\n             ng-class="{\'navigable\': subitem.id}"\n             ng-if="$ctrl.subItems && !$ctrl.lockClicking"\n             ng-repeat="subitem in $ctrl.subItems track by $index"\n             ng-click="$ctrl.goToSubitem({regIdx: $index, event: $event})">\n            {{ $ctrl.getSubitemName(subitem, $index) }}\n          </p>\n\n          <p class="cart-item__subitem"\n             ng-class="{\'navigable\': subitem.id}"\n             ng-if="$ctrl.subItems && $ctrl.lockClicking"\n             ng-repeat="subitem in $ctrl.subItems track by $index">\n            {{ $ctrl.getSubitemName(subitem, $index) }}\n          </p>\n\n          <p class="cart-item__details"\n             ng-if="!$ctrl.subItems">{{ $ctrl.itemDetails }}</p>\n        </div>\n\n        <div class="cart-item__summary">\n          <p class="cart-item__price" ng-class="{ calculating: $ctrl.itemPriceCalculating }">\n            <span class="cart-item__price--discounted" ng-if="$ctrl.hasPromoCode">{{$ctrl.adjustmentAmount | currency:\'$\':2}}</span>\n            <span class="cart-item__price-span" ng-class="{ discounted: $ctrl.hasPromoCode }">{{ $ctrl.displayPrice() }}</span>\n          </p>\n          <p class="cart-item__actions">\n            <button class="cart-item__actions-link"\n              aria-label="remove registration"\n              ng-if="$ctrl.isRemovable"\n              ng-click="$ctrl.remove({event: $event})"\n            >Remove</button>\n          </p>\n        </div>\n      </div>\n      <fundraising-minimum-disclaimer ng-if="$ctrl.showFrMinimumDisclaimer"\n        minimum-value="$ctrl.totalCommitmentValue"\n        minimum-deadline="$ctrl.itemCommitment.deadline"\n        tooltip-relative-position="\'top right\'"\n        small-version="true"\n        left-offset-px="23"\n        background-color="\'#eeeeee\'"\n      ></fundraising-minimum-disclaimer>\n    ',
  bindings: {
    itemName: '=',
    itemPrice: '<?',
    itemPriceCalculating: '<?',
    itemDetails: '<?',
    itemCommitment: '<?',
    subItems: '<?',
    isRemovable: '<',
    isDisabled: '<?',
    isLast: '<?',
    goToSubitem: '&?',
    edit: '&onEdit',
    onClick: '&?',
    remove: '&onRemove',
    groupSize: '<?',
    adjustmentAmount: '<?',
    hasPromoCode: '<?',
    lockClicking: '<?'
  },
  controller: ["scThemesService", function registrationCartItem(scThemesService) {
    var _this = this;

    this.getSubitemName = function (item, index) {
      var attendeeNumber = _this.groupSize - (_this.subItems.length - (index + 1));
      var _item$first_name = item.first_name,
          firstName = _item$first_name === undefined ? '' : _item$first_name,
          _item$last_name = item.last_name,
          lastName = _item$last_name === undefined ? '' : _item$last_name;

      if ((!firstName || firstName.includes('Attendee')) && !lastName) {
        return 'Attendee ' + attendeeNumber;
      }

      item.first_name = firstName;
      item.last_name = lastName;
      // last name not required, convert to empty string if null
      return item.first_name + ' ' + (item.last_name || '');
    };

    this.primaryColor = scThemesService.active.current.styles.primaryColor;

    this.displayPrice = function () {
      return _this.itemPrice && _this.itemPrice !== '$0.00' ? _this.itemPrice : 'Free';
    };

    this.$onInit = function () {
      this.showFrMinimumDisclaimer = !!this.itemCommitment;
      var commitmentValue = this.showFrMinimumDisclaimer ? this.itemCommitment.value : 0;
      this.totalCommitmentValue = this.subItems && this.subItems.length ? this.subItems.length * commitmentValue : commitmentValue;
    };

    this.$onChanges = function () {
      _this.itemDetails = _this.itemDetails ? _this.itemDetails.replace('Semi-annually', 'Semi-annual') : _this.itemDetails;
    };
  }]
});
})();